/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesopenerror2Inputs */

const en_filesopenerror2 = /** @type {(inputs: Filesopenerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't open. Try again.`)
};

const pt_filesopenerror2 = /** @type {(inputs: Filesopenerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível abrir. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Couldn't open. Try again." |
*
* @param {Filesopenerror2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesopenerror2 = /** @type {((inputs?: Filesopenerror2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesopenerror2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesopenerror2(inputs)
	return pt_filesopenerror2(inputs)
});
export { filesopenerror2 as "filesOpenError" }